import { render, staticRenderFns } from "./SaveMeshDialog.vue?vue&type=template&id=461b035f&"
import script from "./SaveMeshDialog.vue?vue&type=script&lang=ts&"
export * from "./SaveMeshDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports